export default
{
    watch:
    {
        minDate()
        {
            let dt = this.$dateUtil.validateDateRange( this.monthDate, this.minDate || new Date(), this.maxDate );

            this.changeLeftMonth({ year: dt.getFullYear(), month: dt.getMonth() + 1 });
        },

        maxDate()
        {
            let dt = this.$dateUtil.validateDateRange( this.nextMonthDate, this.minDate, this.maxDate || new Date() );

            this.changeRightMonth({ year: dt.getFullYear(), month: dt.getMonth() + 1 });
        },

        'modelValue.startDate'( value )
        {
            if( !Boolean( value ) )
            {
                this.start = null;

                return;
            }

            if( !this.$dateUtil.isValidDate( new Date( value ) ) )
            {
                return;
            }

            this.start = ( !!value && !this.isClear && this.$dateUtil.isValidDate( new Date( value ) ) ) ? new Date( value ) : null;

            if( this.isClear )
            {
                this.start = null; this.end = null;
            }
            else
            {
                this.start = new Date( this.modelValue.startDate );
            }
        },

        'modelValue.endDate'( value )
        {
            if( !Boolean( value ) )
            {
                this.end = null;

                return;
            }

            if( !this.$dateUtil.isValidDate( new Date(value ) ) )
            {
                return;
            }

            this.end = ( !!value && !this.isClear ) ? new Date( value ) : null;

            if( this.isClear )
            {
                this.start = null; this.end = null;
            }
            else
            {
                this.end = new Date( this.modelValue.endDate );
            }
        },

        open:
        {
            immediate: true,

            handler( value )
            {
                if( typeof document === "object" )
                {
                    this.$nextTick( () =>
                    {
                        value ? document.body.addEventListener('click', this.clickAway) : document.body.removeEventListener('click', this.clickAway);
                        value ? document.addEventListener('keydown', this.handleEscape) : document.removeEventListener('keydown', this.handleEscape);

                        if( !this.alwaysShowCalendars && this.ranges )
                        {
                            this.showCustomRangeCalendars = !Object.keys( this.ranges ).find( key => this.$dateUtil.isSame( this.start, this.ranges[key][0], 'date' ) && this.$dateUtil.isSame( this.end, this.ranges[key][1], 'date' ) )
                        }
                    })
                }
            }
        }
    }
}
